export default "__VITE_ASSET__1OBFHKfV__"